import { useCallback, useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import get from 'lodash/get'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'

import TextInput from 'common/forms/inputs/TextInput'
import { useTranslations } from 'common/language'
import { Button, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


ShareModal.propTypes = {
  onHide: PropTypes.func.isRequired,
}

export default function ShareModal({ onHide }) {
  const { gettext, languageCode } = useTranslations()
  const handleCopy = useCallback(() => {
    document.getElementById('share').select()
    document.execCommand('copy')
  })
  const quoteUuid = useSelector(state => get(state, 'quoteList.data.id'), shallowEqual)
  const utmTag = useSelector(state => get(state, 'utmData.data.quote_utm_tags.share_link_tags', ''), shallowEqual)
  let value = useMemo(() => `${location.origin}/${languageCode}/quote/list/${quoteUuid}`, [quoteUuid, languageCode])
  if(utmTag) {
    value = value + `?${utmTag}`
  }
  return (
    <div>
      <div className={classNames.modalTextBlock}>
        <div>
          <FontAwesomeIcon icon="share-square" className={classNames.shareIcon} />
        </div>
        <Typography variant="h3">
          {gettext('Share Link')}
        </Typography>
      </div>
      <TextInput id="share" value={value} inputClassName={classNames.shareLink} onChange={noop} />
      <div className={classNames.modalButtons}>
        <Button onClick={handleCopy}>
          {gettext('Copy Link')}
        </Button>
        <Button type="secondary" onClick={onHide}>
          {gettext('Cancel')}
        </Button>
      </div>
    </div>
  )
}
